import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './LoginPage.css';
import { login } from '@/features/auth/authService.js';
import { jwtDecode } from 'jwt-decode';
import JSEncrypt from 'jsencrypt';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = useCallback(
    async (e) => {
      e.preventDefault();
      setIsLoading(true);
      setError('');

      try {
        const response = await login(username, password);
        if (response.status === 200) {
          const { token, refreshToken, deviceId } = response.data;
          const decodedToken = jwtDecode(token);
          // 将用户信息和令牌存储到 sessionStorage
          const setSessionStorage = () => {
            return new Promise((resolve) => {
              sessionStorage.setItem('isLoggedIn', 'true');
              sessionStorage.setItem('username', decodedToken.username);
              sessionStorage.setItem('userid', decodedToken.id);
              sessionStorage.setItem('companyName', decodedToken.companyName);
              sessionStorage.setItem('role_name', decodedToken.role_name);
              sessionStorage.setItem('role_id', decodedToken.role_id);
              sessionStorage.setItem('token', token);
              sessionStorage.setItem('refreshToken', refreshToken);
              sessionStorage.setItem('deviceId', deviceId);
              resolve();
            });
          };

          await setSessionStorage();

          // 清理输入框
          setUsername('');
          setPassword('');
          // 跳转到主页
          navigate('/clients');
        } else {
          setError('登录失败，请稍后再试');
        }
      } catch (error) {
        console.log('error is:', error);
        if (error.response && error.response.status === 401) {
          setError('用户名或密码不正确，请重新输入');
        } else if (error.response && error.response.status === 500) {
          setError('服务器错误，请稍后再试');
        } else {
          setError('登录失败，请稍后再试');
        }
      } finally {
        setIsLoading(false);
      }
    },
    [username, password, navigate]
  );

  return (
    <div className="login-page">
      <h2>登 录</h2>
      <form onSubmit={handleLogin}>
        <div className="input-container">
          <i className="bi bi-person icon"></i>
          <input
            type="text"
            placeholder="请输入账号"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="input-container password-container">
          <i className="bi bi-lock icon"></i>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="请输入密码"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword((s) => !s)}
            aria-label={showPassword ? '隐藏密码' : '显示密码'}
          >
            <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} />
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" disabled={isLoading}>
          {isLoading ? '登录中...' : '登 录'}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
